import React, { Component } from "react";
import PropTypes from "prop-types";

import { Mutation } from "react-apollo";
import { Fieldset, Field, Control, Button } from "rbx";
import Section from "../Section";
import { CREATE_GL_MAIN_ACCOUNT_MUTATION } from "../../graphql/GLMainAccounts/GLMainAccounts.graphql";
import { ourToast as toast } from "../../utils";

import GLMainAccountForm from "./GLMainAccountForm";

import { ErrorMessage } from "../ErrorMessage";

class AddGLMainAccountForm extends Component {
  state = {
    MainAccountId: "",
    Description: "",
    TypeRecIdRef: "",
    Active: true
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  render() {
    const { MainAccountId, Description, TypeRecIdRef, Active } = this.state;
    const { onComplete } = this.props;
    return (
      <Mutation
        mutation={CREATE_GL_MAIN_ACCOUNT_MUTATION}
        refetchQueries={["ALL_GL_MAIN_ACCOUNTS_QUERY"]}
        variables={{
          data: {
            MainAccountId,
            Description,
            TypeRecIdRef: parseInt(TypeRecIdRef),
            Active
          }
        }}
      >
        {(createAccount, { loading, error }) => (
          <Section title="Add Account">
            <form
              id="add-gl-main-account"
              onSubmit={async e => {
                e.preventDefault();

                try {
                  await createAccount();
                  onComplete();
                  toast.success("Account added successfully.");
                } catch (err) {
                  toast.error("Error adding Account.");
                }
              }}
            >
              <ErrorMessage error={error} />
              <Fieldset disabled={loading}>
                <GLMainAccountForm
                  inputs={{
                    MainAccountId,
                    Description,
                    TypeRecIdRef,
                    Active
                  }}
                  onChange={this.onChange}
                />
                <hr />
                <Field kind="group">
                  <Control>
                    <Button
                      color="success"
                      form="add-gl-main-account"
                      type="submit"
                    >
                      Submit
                    </Button>
                  </Control>
                  <Control>
                    <Button type="button" onClick={onComplete}>
                      Cancel
                    </Button>
                  </Control>
                </Field>
              </Fieldset>
            </form>
          </Section>
        )}
      </Mutation>
    );
  }
}

AddGLMainAccountForm.propTypes = {
  onComplete: PropTypes.func
};
export default AddGLMainAccountForm;
